/* import __COLOCATED_TEMPLATE__ from './action-published-details.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface ActionPublishedDetailsArgs {
  event: {
    value: {
      messenger_installed_and_protected: boolean;
      otp_auth_enabled: boolean;
    };
  };
}

export default class ActionPublishedDetails extends Component<ActionPublishedDetailsArgs> {
  @tracked showModal = false;

  get isMessengerInstalledAndProtected() {
    return this.args.event.value.messenger_installed_and_protected;
  }

  get isOtpAuthEnabled() {
    return this.args.event.value.otp_auth_enabled;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TableCells::AdminEvents::ActionPublishedDetails': typeof ActionPublishedDetails;
    'table-cells/admin-events/action-published-details': typeof ActionPublishedDetails;
  }
}
